export const calculateGST = (total, currency, taxRate) => (
  parseFloat((total - (total / (1 + (taxRate / 100)))).toFixed(2))
);



// WEBPACK FOOTER //
// ./src/js/utils/gst.js